import { Component, OnInit,  ViewChildren } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
declare var $: any;
import { Mgt2Service } from 'src/app/services/mgt2.service';
import * as _ from 'lodash';
import { DataTableDirective } from 'angular-datatables';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
@Component({
  selector: 'app-mgt2add',
  templateUrl: './mgt2add.component.html',
  styleUrls: ['./mgt2add.component.css']
})
export class Mgt2addComponent implements OnInit {
  @ViewChildren(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtOptionsOfdepositor: DataTables.Settings = {};
  masterDirectorList: any[];
  editList: any = [];
  addForm: FormGroup;
  addList: any = [];
  rows: FormArray;
  itemForm: FormGroup;
  // showIndividualYes: any;
  showBodyCorporateYes: any;
  showminorYesClick: boolean;
  dtTrigger: Subject<any> = new Subject();
  dtTriggerDeposit: Subject<any> = new Subject();
  dtTriggerdepositor: Subject<any> = new Subject();
  DepositDetailList: any[];
  depositor: any = [];
  SecurityDetailList: any[];
  public environmentSettings: any;
  public downloadAllLink: string = "documentManagement/downloadSingleFileOnID/";
  depositorEditList: any[];
  depositorDetailsList: any[];
  globalDepositID: any;
  public isVisible: boolean = false;
  editRemarkId: any;
  depositorList: any = [];
  editForm: FormGroup;
  id: string = '';
  remarks = '';
  remarks1 = '';
  dateOfDeposit: '';
  Amount: '';
  depoForm: FormGroup;
  depoList: any[];
  depositForm: FormGroup;
  depositlist : any[];
  isSearchDivVisible = false;

  secForm: FormGroup;
  personaldetailsForm: FormGroup;
  holdingForm: FormGroup;
  holdingdata:any;
  showIndividualYes : boolean;
  showbodyCorporateYes : boolean;
  showHolderYes : boolean;
  minorYes : boolean;
  minorNo : boolean;
  RepaymentYes : boolean;
  restrictmgt2TabFlag: boolean;
  editMgt2Data: any = [];
  editParticularId: any;
  addPersonalBtn = true;
  dateOfBirthModel: any;
  dateOfBoardModel: any;
  addHoldingBtn = true;
  DateOfDebentureModel: any;
  DateOfreceiptModel: any;
  dateOfCessationModel: any;
  dateOfRegisterModel: any;
  dateOfDebentureHolderModel: any;
  dateOfCessationDebentureHolderModel: any;
  dateOfRegistrationModel: any;
  dateOfReceiptModel: any;
  dateOfCessationDebentureHolderOtherModel: any;
  dateOfRegistrationROCOthersModel: any;
  showTable: boolean;
  addholding = true;
  addButton: boolean =true;
  deleteButton: boolean =true;
  securityUpdate: boolean =true;
  addSecurityForm: FormGroup;
  newFieldArray: { id: number; title: string; }[];
  newFieldAttribute: any;
  holdingList:any;
  dtTriggerHolding : Subject<any> = new Subject();
  dtOptionsOfHolding : DataTables.Settings = {};
  deleteholdingId:any;
  updateRecordId:any;
  filesToUpload: Array<File>;
  fileAvailable = false;
  canRevert: boolean;
  resolutionFileName: any;
  documentManagementID: any;
  FileOrignalName: any;
  changedName: any;
  countryList: any[];
  disabledOnClick: boolean;
  fileExtension: boolean = true;
  typeOfholder: any;
  token: any = localStorage.getItem('token');
  showTermLoadFields = false;
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  dateFrom:any;
  dateTo:any;
  response: boolean;
  array:any;
  holdersdata: any;

  constructor(private Mgt2Service: Mgt2Service,private router: Router,private activatedRoute: ActivatedRoute,
    private alert: AlertComponent,private fb: FormBuilder,private documentManagementMasterService: DocumentManagementMasterService,
    private commonFunction: CommonFunction, private directorMasterService: DirectorMasterService ) {

      this.addForm = this.fb.group({
      });
   
      this.rows = this.fb.array([]);
     }

  ngOnInit() {

    this.secForm = new FormGroup({
      selectTypes: new FormControl('', [Validators.required]),
      nominalValue: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /.,-]*$"), Validators.maxLength(10)]),
      numberOfDebenture: new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z0-9 /.,-]*$"), Validators.maxLength(20)]),
      classOfDebenture: new FormControl('',[Validators.pattern("^[a-zA-Z /().,-]*$"  ), Validators.maxLength(50)]),
      otherSecurities: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /().,-]*$"  ), Validators.maxLength(200)]),
      folioNumber: new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z0-9 /.,-]*$"), Validators.maxLength(30)]),
    })

    // ******** Personal Form *************
    this.personaldetailsForm = new FormGroup({
      holders: new FormControl('',[Validators.required]),
      debentureName: new FormControl('',[]),
      jointholder: new FormControl('',[]),
      address: new FormControl('',[]),
      // panNumber: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(10)]),
      panNumber: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      identificationNumber: new FormControl('',[]),
      nationality: new FormControl('',[]),
      emailid: new FormControl('',[Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      fatherName: new FormControl('',[Validators.pattern("^[a-zA-Z &.,-]*$"), Validators.maxLength(30)]),
      motherName: new FormControl('',[Validators.pattern("^[a-zA-Z &.,-]*$"), Validators.maxLength(30)]),
      nameOfJointHolder: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /.&,-]*$"), Validators.maxLength(100)]),
      jointholderpanNumber: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      isMinor: new FormControl('',[]),
      passportNumber: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      adharNumber: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      voterId: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      drivingLicense: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      others: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      dateOfBirth: new FormControl('',[]),
      guardian: new FormControl('',[Validators.maxLength(1000)]),
      spouseName: new FormControl('',[Validators.pattern("^[a-zA-Z &.,-]*$"), Validators.maxLength(20)]),
      maritialstatus: new FormControl('',[]),
      occupation: new FormControl('',[Validators.pattern("^[a-zA-Z ./-]*$"), Validators.maxLength(20)]),
      debentureNameBodyCorporate: new FormControl('',[]),
      registeredAddressBodyCorporate: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 ()/.&,-]*$"), Validators.maxLength(200)]),
      panNumberBodyCorporate: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      registrationNumberBodyCorporate: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      emailIdBodyCorporate: new FormControl('',[Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      authorisedSignatoryBodyCorporate: new FormControl('',[Validators.maxLength(20)]),
      designationBodyCorporate: new FormControl('',[Validators.maxLength(20)]),
      dateOfBoardBodyCorporate: new FormControl('',[]),
      uploadBodyCorporate: new FormControl('',[]),
      debentureNameOthers: new FormControl('',[]),
      jointHolderOthers: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /.&,-]*$"), Validators.maxLength(100)]),
      addressOthers: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /.&,-]*$"), Validators.maxLength(200)]),
      panNumberOthers: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      identificationNumberOthers: new FormControl('',[]),
      passportNumberOthers: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      adharNumberOthers: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      voterIdOthers: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      drivingLicenseOthers: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      othersOthers: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(30)]),
      nationalityOthers: new FormControl('',[]),
      emailOthers: new FormControl('',[Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
    })

    // ******** Holding Form *************
    this.holdingForm = new FormGroup({
      typesOfHolders: new FormControl('',[Validators.required]),
      dateOfDebenture: new FormControl('',[]),
      dateOfreceipt: new FormControl('',[]),
      nomineeAddress: new FormControl('',[]),
      noOfDebenture: new FormControl('',[]),
      record: new FormControl('',[]),
      dateOfCessation: new FormControl('',[]),
      nomineeName: new FormControl('',[]),
      isRepayment: new FormControl('',[]),
      chargeIdentificationNumber: new FormControl('',[]),
      dateOfRegister: new FormControl('',[]),
      breifParticulars: new FormControl('',[]),
      interestMandates: new FormControl('',[]),
      instruction: new FormControl('',[]),
      ref1: new FormControl('',[]),
      dobDebentureHolderOtherSecurityHolder: new FormControl('',[]),
      recordLienOnDebenturesSecuritiesIfAny: new FormControl('',[]),
      doCessationAsDebentureHolderOtherSecurityHolder: new FormControl('',[]),
      whetherRepaymentoftheDebenturesOtherSecuritiesisSecured: new FormControl('',[]),
      ifSecuredDoRegistrationOfChangeWithTheROC: new FormControl('',[]),
      chargeIdentificationNumberAllocatedForCharge: new FormControl('',[]),
      briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities: new FormControl('',[]),
      particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny: new FormControl('',[]),
      instructionForSendingNoticesEtcIfAny: new FormControl('',[]),
      refInCHG7: new FormControl('',[]),
      dobDebentureHolderOtherSecurityHolderOthers: new FormControl('',[]),
      doReceiptOfNomination: new FormControl('',[]),
      nameOfNominee: new FormControl('',[]),
      addressOfNominee: new FormControl('',[]),
      noOfDebenturesSecuritiesKeptInAbeyanceIfAny: new FormControl('',[]),
      recordOfLienOnDebenturesSecuritiesIfAny: new FormControl('',[]),
      doCessationAsDebentureHolderOtherSecurityHolderOthers: new FormControl('',[]),
      whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers: new FormControl('',[]),
      ifSecuredDoRegistrationOfChangeWithTheROCOthers: new FormControl('',[]),
      chargeIdentificationNumberAllocatedForChargeOthers: new FormControl('',[]),
      briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities: new FormControl('',[]),
      particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers: new FormControl('',[]),
      instructionForSendingNoticesEtcIfAnyOthers: new FormControl('',[]),
      refInCHG7Others: new FormControl('',[]),
    })

    this.addForm = new FormGroup({
      typeOfHolding: new FormControl('', []),
      allotmentNumber: new FormControl('', []),
      dateOfAllotment: new FormControl('', []),
      numberOfSecurities: new FormControl('', []),
      distinctiveNumber: new FormControl('', []),
      numberFrom: new FormControl('', []),
      numberTo: new FormControl('', []),
      folio: new FormControl('', []),
      nameOfTransferor: new FormControl('', []),
      dateOfIssue: new FormControl('', []),
      certificateNumber: new FormControl('', []),
      lock: new FormControl('', []),
      amount: new FormControl('', []),
      amountPayable: new FormControl('', []),
      amountPaid: new FormControl('', []),
      amountDue: new FormControl('', []),
      breifDebenture: new FormControl('', []),
      dateOfTransfer: new FormControl('', []),
      numberOfTransfer: new FormControl('', []),
      distinctiveNumberTransfer: new FormControl('', []),
      distinctiveNumberTransferFrom: new FormControl('', []),
      distinctiveNumberTransferTo: new FormControl('', []),
      folioTransferee: new FormControl('', []),
      nameTransferee: new FormControl('', []),
      balanceLeft: new FormControl('', []),
      otherRemarks: new FormControl('', []),
 
    })
    this.addForm.addControl('rows', this.rows);

    this.editForm = this.fb.group({
      'typeOfHolding': [],
      'allotmentNumber': [],
      'dateOfAllotment': [],
      'numberOfSecurities': [],
      'distinctiveNumber': [],
      'numberFrom': [],
      'numberTo': [],
      'folio': [],
      'nameOfTransferor': [],
      'dateOfIssue': [],
      'certificateNumber': [],
      'lock': [],
      'amount': [],
      'amountPayable': [],
      'amountPaid': [],
      'amountDue': [],
      'breifDebenture': [],
      'dateOfTransfer': [],
      'numberOfTransfer': [],
      'distinctiveNumberTransfer': [],
      'distinctiveNumberTransferFrom': [],
      'distinctiveNumberTransferTo': [],
      'folioTransferee': [],
      'nameTransferee': [],
      'balanceLeft': [],
      'otherRemarks': []
      
    });

    this.getAllNations();

    const control = <FormArray>this.rows
    for (let i = control.length - 1; i >= 0; i--) {
      control.removeAt(i);
    }

    this.getDetailOfSecurityList(); {
      this.dtOptions = {
        destroy: true,
        pagingType: 'full_numbers',
        paging: true,
        pageLength: 50,
        stateSave: true,
        stateDuration: -1,
        search: true,
        order: [0, 'asc'],
        lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
        columnDefs: [{ orderable: false, targets: [7] }]
      };
    }

    this.activatedRoute.params.subscribe(params => {
      //console.log('particularId',params['particularId']);
      if (params['particularId'] != undefined) {
        this.restrictmgt2TabFlag = true;
        this.editParticularId = params['particularId'];
        this.getMgt2ById(this.editParticularId);
      } else {
        this.restrictmgt2TabFlag = false;
      }
    })

    this.addSecurityForm = this.fb.group({
      newField: new FormArray([   
      ]),
    });
    this.newFieldArray = [];

    this.dtOptionsOfHolding = {
      destroy: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: []
  
    };
    this.getHoldingList();
      
  } // On Init End
  backMGT2(){
    
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mgt2']  } }],
      { relativeTo: this.activatedRoute.parent });
      }
      toggleSearchDiv() {
        this.isSearchDivVisible = !this.isSearchDivVisible;
      }
  getAllNations() {
    this.directorMasterService.getNations().subscribe((relativeUpdate:any) => {
      this.countryList = this.commonFunction.sortByKey(relativeUpdate.countryList, 'Country');
      // console.log('relativeUpdate : ' + JSON.stringify(this.countryList));
    });
  }

  securityOnChange(securityValue)
  {
    if(securityValue=='debentures')
    {
      this.secForm.controls.classOfDebenture.setValidators([Validators.required,Validators.pattern("^[a-zA-Z /.,-]*$"), Validators.maxLength(50)]);
      this.secForm.controls.otherSecurities.setValue('');
    }
    else if(securityValue=='otherssecurities')
    {
      this.secForm.controls.classOfDebenture.setValidators([]);
      this.secForm.controls.classOfDebenture.setValue('');
    }
  }

  savesecdata(){
    
  this.disabledOnClick = true;
    var object = {
      selectTypes : this.secForm.controls.selectTypes.value,
      nominalValue: this.secForm.controls.nominalValue.value,
      numberOfDebenture: this.secForm.controls.numberOfDebenture.value,
      classOfDebenture: this.secForm.controls.classOfDebenture.value,
      otherSecurities: this.secForm.controls.otherSecurities.value,
      folioNumber: this.secForm.controls.folioNumber.value,
    }
    this.Mgt2Service.samplemgt2Record(object).subscribe(response => {
      
  this.disabledOnClick = false;
      // console.log(response);
      if (response.status == 0) {
        this.alert.successWithOk("Type of securities added successfully.", 'mgt2/edit/'+response.data._id);
        //this.alert.success(response.message);
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })
  }

  updateSecParticulars() {
    
  this.disabledOnClick = true;
    var object = {
      selectTypes : this.secForm.controls.selectTypes.value,
      nominalValue: this.secForm.controls.nominalValue.value,
      numberOfDebenture: this.secForm.controls.numberOfDebenture.value,
      classOfDebenture: this.secForm.controls.classOfDebenture.value,
      otherSecurities: this.secForm.controls.otherSecurities.value,
      folioNumber: this.secForm.controls.folioNumber.value,
    }
    this.Mgt2Service.updateSecParticulars(object, this.editParticularId).subscribe(response => {
      
  this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.success(response.message);
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })
  }

  personalDetailsTOHChange(holderType)
  {
    // console.log('editMgt2Data : ' + JSON.stringify(this.editMgt2Data.personal));
    if(holderType=='individual'){ this.onIndividualSelect(); }
    else if(holderType=='bodyCorporate'){ this.onBodyCorporateSelect(); }
    else if(holderType=='others'){ this.onOtherSelect(); }
  }
  onIndividualSelect()
  {
      this.personaldetailsForm.controls.debentureName.setValidators([Validators.required,Validators.pattern("^[a-zA-Z0-9 &.,-]*$"), Validators.maxLength(100)]);
      this.personaldetailsForm.controls.debentureNameBodyCorporate.setValidators([]);
      this.personaldetailsForm.controls.debentureNameOthers.setValidators([]);
      this.showHolderYes=false;
      this.minorYes=false;
      this.minorNo=false;
      // body corprate form blank
      this.personaldetailsForm.controls.debentureNameBodyCorporate.setValue('');
      this.personaldetailsForm.controls.registeredAddressBodyCorporate.setValue('');
      this.personaldetailsForm.controls.panNumberBodyCorporate.setValue('');
      this.personaldetailsForm.controls.registrationNumberBodyCorporate.setValue('');
      this.personaldetailsForm.controls.emailIdBodyCorporate.setValue('');
      this.personaldetailsForm.controls.authorisedSignatoryBodyCorporate.setValue('');
      this.personaldetailsForm.controls.designationBodyCorporate.setValue('');
      this.personaldetailsForm.controls.dateOfBoardBodyCorporate.setValue(null);
      this.personaldetailsForm.controls.uploadBodyCorporate.setValue('');
       // other form blank
       this.personaldetailsForm.controls.debentureNameOthers.setValue('');
       this.personaldetailsForm.controls.jointHolderOthers.setValue('');
       this.personaldetailsForm.controls.addressOthers.setValue('');
       this.personaldetailsForm.controls.panNumberOthers.setValue('');
       this.personaldetailsForm.controls.identificationNumberOthers.setValue('');
       this.personaldetailsForm.controls.nationalityOthers.setValue('');
       this.personaldetailsForm.controls.emailOthers.setValue('');
  }
  onBodyCorporateSelect()
  {
      this.personaldetailsForm.controls.debentureNameBodyCorporate.setValidators([Validators.required,Validators.pattern("^[a-zA-Z0-9 &.,-]*$"), Validators.maxLength(100)]);
      this.personaldetailsForm.controls.debentureName.setValidators([]);
      this.personaldetailsForm.controls.debentureNameOthers.setValidators([]);
      // individual form blank
      this.personaldetailsForm.controls.debentureName.setValue('');
      this.personaldetailsForm.controls.address.setValue('');
      this.personaldetailsForm.controls.identificationNumber.setValue('');
      this.personaldetailsForm.controls.panNumber.setValue('');
      this.personaldetailsForm.controls.nationality.setValue('');
      this.personaldetailsForm.controls.emailid.setValue('');
      this.personaldetailsForm.controls.fatherName.setValue('');
      this.personaldetailsForm.controls.motherName.setValue('');
      this.personaldetailsForm.controls.jointholder.setValue('');
      this.showHolderYes=false;
      this.personaldetailsForm.controls.isMinor.setValue('');
      this.personaldetailsForm.controls.maritialstatus.setValue('');
      this.minorYes=false;
      this.minorNo=false;
      this.personaldetailsForm.controls.occupation.setValue('');
      // other form blank
      this.personaldetailsForm.controls.debentureNameOthers.setValue('');
      this.personaldetailsForm.controls.jointHolderOthers.setValue('');
      this.personaldetailsForm.controls.addressOthers.setValue('');
      this.personaldetailsForm.controls.panNumberOthers.setValue('');
      this.personaldetailsForm.controls.identificationNumberOthers.setValue('');
      this.personaldetailsForm.controls.nationalityOthers.setValue('');
      this.personaldetailsForm.controls.emailOthers.setValue('');
  }
  onOtherSelect()
  {
      this.personaldetailsForm.controls.debentureNameOthers.setValidators([Validators.required,Validators.pattern("^[a-zA-Z0-9 &.,-]*$"), Validators.maxLength(100)]);
      this.personaldetailsForm.controls.debentureName.setValidators([]);
      this.personaldetailsForm.controls.debentureNameBodyCorporate.setValidators([]);
      // individual form blank
      this.personaldetailsForm.controls.debentureName.setValue('');
      this.personaldetailsForm.controls.address.setValue('');
      this.personaldetailsForm.controls.identificationNumber.setValue('');
      this.personaldetailsForm.controls.panNumber.setValue('');
      this.personaldetailsForm.controls.nationality.setValue('');
      this.personaldetailsForm.controls.emailid.setValue('');
      this.personaldetailsForm.controls.fatherName.setValue('');
      this.personaldetailsForm.controls.motherName.setValue('');
      this.personaldetailsForm.controls.jointholder.setValue('');
      this.showHolderYes=false;
      this.personaldetailsForm.controls.isMinor.setValue('');
      this.personaldetailsForm.controls.maritialstatus.setValue('');
      this.minorYes=false;
      this.minorNo=false;
      this.personaldetailsForm.controls.occupation.setValue('');
      // body corprate form blank
      this.personaldetailsForm.controls.debentureNameBodyCorporate.setValue('');
      this.personaldetailsForm.controls.registeredAddressBodyCorporate.setValue('');
      this.personaldetailsForm.controls.panNumberBodyCorporate.setValue('');
      this.personaldetailsForm.controls.registrationNumberBodyCorporate.setValue('');
      this.personaldetailsForm.controls.emailIdBodyCorporate.setValue('');
      this.personaldetailsForm.controls.authorisedSignatoryBodyCorporate.setValue('');
      this.personaldetailsForm.controls.designationBodyCorporate.setValue('');
      this.personaldetailsForm.controls.dateOfBoardBodyCorporate.setValue(null);
      this.personaldetailsForm.controls.uploadBodyCorporate.setValue('');
  }

  detailsOfHoldingTOHChange(typeOfHolder)
  {
    if(typeOfHolder=='individual'){ this.detailsOfHoldingIndividualSelect(); }
    else if(typeOfHolder=='bodyCorporate'){ this.detailsOfHoldingBodyCorporateSelect(); }
    else if(typeOfHolder=='others'){ this.detailsOfHoldingOtherSelect(); }
  }

  detailsOfHoldingIndividualSelect()
  {
    // detailsOfHoldingOther
    this.holdingForm.controls.dobDebentureHolderOtherSecurityHolderOthers.setValue(null);
    this.holdingForm.controls.doReceiptOfNomination.setValue(null);
    this.holdingForm.controls.nameOfNominee.setValue('');
    this.holdingForm.controls.addressOfNominee.setValue('');
    this.holdingForm.controls.noOfDebenturesSecuritiesKeptInAbeyanceIfAny.setValue('');
    this.holdingForm.controls.recordOfLienOnDebenturesSecuritiesIfAny.setValue('');
    this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolderOthers.setValue(null);
    this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.setValue('');
    this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROCOthers.setValue(null);
    this.holdingForm.controls.chargeIdentificationNumberAllocatedForChargeOthers.setValue('');
    this.holdingForm.controls.briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities.setValue('');
    this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers.setValue('');
    this.holdingForm.controls.instructionForSendingNoticesEtcIfAnyOthers.setValue('');
    this.holdingForm.controls.refInCHG7Others.setValue('');
    this.RepaymentYes=false;

    // detailsOfHoldingBodyCorporate
    this.holdingForm.controls.dobDebentureHolderOtherSecurityHolder.setValue(null);
    this.holdingForm.controls.recordLienOnDebenturesSecuritiesIfAny.setValue('');
    this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolder.setValue(null);
    this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.setValue('');
    this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROC.setValue(null);
    this.holdingForm.controls.chargeIdentificationNumberAllocatedForCharge.setValue('');
    this.holdingForm.controls.briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities.setValue('');
    this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny.setValue('');
    this.holdingForm.controls.instructionForSendingNoticesEtcIfAny.setValue('');
    this.holdingForm.controls.refInCHG7.setValue('');
  }

  detailsOfHoldingBodyCorporateSelect()
  {
     // detailsOfHoldingOther
     this.holdingForm.controls.dobDebentureHolderOtherSecurityHolderOthers.setValue(null);
     this.holdingForm.controls.doReceiptOfNomination.setValue(null);
     this.holdingForm.controls.nameOfNominee.setValue('');
     this.holdingForm.controls.addressOfNominee.setValue('');
     this.holdingForm.controls.noOfDebenturesSecuritiesKeptInAbeyanceIfAny.setValue('');
     this.holdingForm.controls.recordOfLienOnDebenturesSecuritiesIfAny.setValue('');
     this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolderOthers.setValue(null);
     this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.setValue('');
     this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROCOthers.setValue(null);
     this.holdingForm.controls.chargeIdentificationNumberAllocatedForChargeOthers.setValue('');
     this.holdingForm.controls.briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities.setValue('');
     this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers.setValue('');
     this.holdingForm.controls.instructionForSendingNoticesEtcIfAnyOthers.setValue('');
     this.holdingForm.controls.refInCHG7Others.setValue('');
    // detailsOfHoldingIndividual
    this.holdingForm.controls.dateOfDebenture.setValue(null);
    this.holdingForm.controls.dateOfreceipt.setValue(null);
    this.holdingForm.controls.nomineeName.setValue('');
    this.holdingForm.controls.nomineeAddress.setValue('');
    this.holdingForm.controls.noOfDebenture.setValue('');
    this.holdingForm.controls.record.setValue('');
    this.holdingForm.controls.dateOfCessation.setValue(null);
    this.holdingForm.controls.isRepayment.setValue('');
    this.holdingForm.controls.chargeIdentificationNumber.setValue('');
    this.holdingForm.controls.dateOfRegister.setValue(null);
    this.holdingForm.controls.breifParticulars.setValue('');
    this.holdingForm.controls.interestMandates.setValue('');
    this.holdingForm.controls.instruction.setValue('');
    this.holdingForm.controls.ref1.setValue('');
    this.RepaymentYes = false;
    this.fileAvailable = false
  }

  detailsOfHoldingOtherSelect()
  {
    
    // detailsOfHoldingBodyCorporate
    this.holdingForm.controls.dobDebentureHolderOtherSecurityHolder.setValue(null);
    this.holdingForm.controls.recordLienOnDebenturesSecuritiesIfAny.setValue('');
    this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolder.setValue(null);
    this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.setValue('');
    this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROC.setValue(null);
    this.holdingForm.controls.chargeIdentificationNumberAllocatedForCharge.setValue('');
    this.holdingForm.controls.briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities.setValue('');
    this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny.setValue('');
    this.holdingForm.controls.instructionForSendingNoticesEtcIfAny.setValue('');
    this.holdingForm.controls.refInCHG7.setValue('');
    // detailsOfHoldingIndividual
    this.holdingForm.controls.dateOfDebenture.setValue(null);
    this.holdingForm.controls.dateOfreceipt.setValue(null);
    this.holdingForm.controls.nomineeName.setValue('');
    this.holdingForm.controls.nomineeAddress.setValue('');
    this.holdingForm.controls.noOfDebenture.setValue('');
    this.holdingForm.controls.record.setValue('');
    this.holdingForm.controls.dateOfCessation.setValue(null);
    this.holdingForm.controls.isRepayment.setValue('');
    this.holdingForm.controls.chargeIdentificationNumber.setValue('');
    this.holdingForm.controls.dateOfRegister.setValue(null);
    this.holdingForm.controls.breifParticulars.setValue('');
    this.holdingForm.controls.interestMandates.setValue('');
    this.holdingForm.controls.instruction.setValue('');
    this.holdingForm.controls.ref1.setValue('');
    this.RepaymentYes=false;
  }

  getDetailOfSecurity(_id): void {
    // console.log(_id);
    this.Mgt2Service.getDetailOfSecurity(_id).subscribe(response => {
      // console.log(response)
      this.id = response.data.Info._id;
      this.editRemarkId = response.data.Info._id;
      this.editForm.setValue({
        typeOfHolding: response.data.Info.typeOfHolding,
        allotmentNumber: response.data.Info.allotmentNumber,
        dateOfAllotment: response.data.Info.dateOfAllotment,
        numberOfSecurities: response.data.Info.numberOfSecurities,
        distinctiveNumber: response.data.Info.distinctiveNumber,
        numberFrom: response.data.Info.numberFrom,
        numberTo: response.data.Info.numberTo,
        folio: response.data.Info.folio,
        nameOfTransferor: response.data.Info.nameOfTransferor,
        dateOfIssue: response.data.Info.dateOfIssue,
        certificateNumber: response.data.Info.certificateNumber,
        lock: response.data.Info.lock,
        amount: response.data.Info.amount,
        amountPayable: response.data.Info.amountPayable,
        amountPaid: response.data.Info.amountPaid,
        amountDue: response.data.Info.amountDue,
        breifDebenture: response.data.Info.breifDebenture,
        dateOfTransfer: response.data.Info.dateOfTransfer,
        numberOfTransfer: response.data.Info.numberOfTransfer,
        distinctiveNumberTransfer: response.data.Info.distinctiveNumberTransfer,
        distinctiveNumberTransferFrom: response.data.Info.distinctiveNumberTransferFrom,
        distinctiveNumberTransferTo: response.data.Info.distinctiveNumberTransferTo,
        folioTransferee: response.data.Info.folioTransferee,
        nameTransferee: response.data.Info.nameTransferee,
        balanceLeft: response.data.Info.balanceLeft,
        otherRemarks: response.data.Info.otherRemarks,
      });
      $("#hello").modal("toggle");
    })
  }

  onFormSubmit(data: NgForm, _id) {
 
    this.Mgt2Service.update(this.editRemarkId, data)
      .subscribe(response => {
        this.getDetailOfSecurityList();
        $("#hello").modal("toggle");
        // let id = response['_id'];
        //  this.router.navigate(['/depositor-details', id]);
      }, (err) => {
        console.log(err);
      }
      );
  }


  generateOutput(id) {
    var object = {
      id: this.editParticularId,
      fromDate: this.dateFrom,
      toDate: this.dateTo
    }
    this.Mgt2Service.generateMgt2Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.Mgt2Service.downloadMgt2File(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.Mgt2Service.downloadMgt2PdfFile(id, 'Single');
  }

  deletesecuritydetail(_id) {
    this.Mgt2Service.removedetails(_id)
 
      .subscribe(response => {
 
        if (response.status == 0) {
          this.SecurityDetailList = [];
          this.getDetailOfSecurityList();
          this.alert.success(' deleted successfully.')
        }
        else {
          this.alert.error('Oops, Something went wrong.')
        }
 
      });
  }

  getDetailOfSecurityList() {
 
    this.SecurityDetailList = [];
    // $("#depositorTable").DataTable().destroy();
    this.Mgt2Service.getSecurityDetails()
      .subscribe(securityList => {
        this.SecurityDetailList = securityList.data;
        // console.log(securityList.data)
        this.dtTrigger.next();
      });
  }

  onAddRow() {
    this.showTable =true;
    this.rows.push(this.createItemFormGroup());
    console.log(this.rows)
  }
  onRemoveRow(rowIndex: number) {
    //this.showTable = false;
    this.rows.removeAt(rowIndex);
  }

  createItemFormGroup(): FormGroup {
    return this.fb.group({
      typeOfHolding: null,
      allotmentNumber: null,
      dateOfAllotment: null,
      numberOfSecurities: null,
      distinctiveNumber: null,
      numberFrom: null,
      numberTo: null,
      folio: null,
      nameOfTransferor: null,
      dateOfIssue: null,
      certificateNumber: null,
      lock: null,
      amount: null,
      amountPayable: null,
      amountPaid: null,
      amountDue: null,
      breifDebenture: null,
      dateOfTransfer: null,
      numberOfTransfer: null,
      distinctiveNumberTransfer: null,
      distinctiveNumberTransferFrom: null,
      distinctiveNumberTransferTo: null,
      folioTransferee: null,
      nameTransferee: null,
      balanceLeft: null,
      otherRemarks: null,
    });
  }

  onSave() {
    console.log(this.rows.value)
    console.log("this.addForm", this.rows.value)
    var securityObjects = {
      typeOfHolding: this.rows.value,
      allotmentNumber: this.rows.value,
      dateOfAllotment: this.rows.value,
      numberOfSecurities: this.rows.value,
      distinctiveNumber: this.rows.value,
      numberFrom: this.rows.value,
      numberTo: this.rows.value,
      folio: this.rows.value,
      nameOfTransferor: this.rows.value,
      dateOfIssue: this.rows.value,
      certificateNumber: this.rows.value,
      lock: this.rows.value,
      amount: this.rows.value,
      amountPayable: this.rows.value,
      amountPaid: this.rows.value,
      amountDue: this.rows.value,
      breifDebenture: this.rows.value,
      dateOfTransfer: this.rows.value,
      numberOfTransfer: this.rows.value,
      distinctiveNumberTransfer: this.rows.value,
      distinctiveNumberTransferFrom: this.rows.value,
      distinctiveNumberTransferTo: this.rows.value,
      folioTransferee: this.rows.value,
      nameTransferee: this.rows.value,
      balanceLeft: this.rows.value,
      otherRemarks: this.rows.value,
    }
    this.Mgt2Service.SecurityDetail(securityObjects).subscribe(response => {
      console.log("response", response);
      //this.addList = response.addList;
    })
  }
  showHolderYesClick() {
    this.showHolderYes = true;
  }
  hideHolderNoClick(){
    this.showHolderYes = false;
    this.personaldetailsForm.controls.nameOfJointHolder.setValue(''); 
    this.personaldetailsForm.controls.jointholderpanNumber.setValue(''); 
  }
  showMinorYesClick(){
    this.minorYes = true;
    this.minorNo = false;
    this.personaldetailsForm.controls.maritialstatus.setValue(''); 
    this.personaldetailsForm.controls.spouseName.setValue(''); 
  }
  hideMinorNoClick(){
    this.minorYes = false;
    this.minorNo = true; 
  }
    memberisMinorChanged() {
    this.personaldetailsForm.controls.dateOfBirth.setValue(null);
    this.personaldetailsForm.controls.guardian.setValue('');
    // this.personaldetailsForm.controls.maritialstatus.setValue('');
    // this.personaldetailsForm.controls.spouseName.setValue('');
  }
  // maritialStatusChanged() {
  //   console.log("*********",this.personaldetailsForm.controls.maritialStatus.value)
  //   this.editMgt2Data.personal.maritialstatus = this.personaldetailsForm.controls.maritialStatus.value;
  //   this.personaldetailsForm.controls.spouseName.setValue('');
  // }

  maritialStatusChanged(event) {
    let maritialstatus = this.personaldetailsForm.controls.maritialstatus.value;
    if (maritialstatus == "married") {
      this.showTermLoadFields = true;
      this.personaldetailsForm.controls.spouseName.setValidators([ Validators.pattern("^[a-zA-Z &.,-]*$"), Validators.maxLength(20)]);
     
    } else {
      this.showTermLoadFields = false;
      this.personaldetailsForm.controls.spouseName.setValidators([]);
     // this.personaldetailsForm.controls.spouseName.setValue('');
    }
    this.personaldetailsForm.controls.spouseName.updateValueAndValidity();
  }

  showRepaymentYesClick(){
    this.RepaymentYes = true;
  }
  hideRepaymentNoClick(){
    this.RepaymentYes = false;
  }

  setDate(date) {
    if (date != "" && date != null && date !=undefined) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  checkUndefinedValue(valueCheck)
  {
    if(valueCheck==undefined)
    {
      return "";
    }
    return valueCheck;
  }

  savepersonaldata(){
    
  this.disabledOnClick = true;
    var self = this;
    if (self.filesToUpload != undefined && self.filesToUpload.length > 0) {
      self.upload().then(function (responseFile:any) {
        // console.log('Res : '+JSON.stringify(responseFile));
        // console.log('Res +++ Res: '+self.editParticularId);
        if (responseFile.status == 0) {
            var personal = {
              particularId:self.editParticularId,
              holders: self.checkUndefinedValue(self.personaldetailsForm.controls.holders.value),
              debentureName: self.checkUndefinedValue(self.personaldetailsForm.controls.debentureName.value),
              jointholder: self.checkUndefinedValue(self.personaldetailsForm.controls.jointholder.value),
              address: self.checkUndefinedValue(self.personaldetailsForm.controls.address.value),
              panNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.panNumber.value),
              identificationNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.identificationNumber.value),
              nationality: self.checkUndefinedValue(self.personaldetailsForm.controls.nationality.value),
              emailid: self.checkUndefinedValue(self.personaldetailsForm.controls.emailid.value),
              fatherName: self.checkUndefinedValue(self.personaldetailsForm.controls.fatherName.value),
              motherName: self.checkUndefinedValue(self.personaldetailsForm.controls.motherName.value),
              nameOfJointHolder: self.checkUndefinedValue(self.personaldetailsForm.controls.nameOfJointHolder.value),
              jointholderpanNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.jointholderpanNumber.value),
              isMinor: self.checkUndefinedValue(self.personaldetailsForm.controls.isMinor.value),
              passportNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.passportNumber.value),
              adharNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.adharNumber.value),
              voterId: self.checkUndefinedValue(self.personaldetailsForm.controls.voterId.value),
              drivingLicense: self.checkUndefinedValue(self.personaldetailsForm.controls.drivingLicense.value),
              others: self.checkUndefinedValue(self.personaldetailsForm.controls.others.value),
              dateOfBirth: self.setDate(self.personaldetailsForm.controls.dateOfBirth.value),
              guardian: self.checkUndefinedValue(self.personaldetailsForm.controls.guardian.value),
              spouseName: self.checkUndefinedValue(self.personaldetailsForm.controls.spouseName.value),
              maritialstatus: self.checkUndefinedValue(self.personaldetailsForm.controls.maritialstatus.value),
              occupation: self.checkUndefinedValue(self.personaldetailsForm.controls.occupation.value),
              debentureNameBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.debentureNameBodyCorporate.value),
              registeredAddressBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.registeredAddressBodyCorporate.value),
              panNumberBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.panNumberBodyCorporate.value),
              registrationNumberBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.registrationNumberBodyCorporate.value),
              emailIdBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.emailIdBodyCorporate.value),
              authorisedSignatoryBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.authorisedSignatoryBodyCorporate.value),
              designationBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.designationBodyCorporate.value),
              dateOfBoardBodyCorporate: self.setDate(self.personaldetailsForm.controls.dateOfBoardBodyCorporate.value),
              uploadBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.uploadBodyCorporate.value),
              debentureNameOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.debentureNameOthers.value),
              jointHolderOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.jointHolderOthers.value),
              addressOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.addressOthers.value),
              panNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.panNumberOthers.value),
              identificationNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.identificationNumberOthers.value),
              passportNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.passportNumberOthers.value),
              adharNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.adharNumberOthers.value),
              voterIdOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.voterIdOthers.value),
              drivingLicenseOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.drivingLicenseOthers.value),
              othersOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.othersOthers.value),
              nationalityOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.nationalityOthers.value),
              emailOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.emailOthers.value),
              FileOrignalName: self.FileOrignalName,
              DocumentManagementID: responseFile.result._id,
              UploadDate: new Date(),
            }
            // console.log('editParticularId : '+self.editParticularId);
            self.Mgt2Service.samplemgt2personalRecord(personal).subscribe(response => {
              self.disabledOnClick = false;
              // console.log("response", JSON.stringify(response));
              if (response.status == 0) {
                self.alert.success(response.message);
                self.addPersonalBtn = false;
              } else {
                if(response.err_fields){
                  self.alert.error(response.err_fields + ' fields are required or invalid.');
                }else{
                  self.alert.error(response.message);
                }
              }
            })
        }
      })
    } else {
      this.disabledOnClick = true;
          var personal = {
            particularId:self.editParticularId,
            holders: self.checkUndefinedValue(self.personaldetailsForm.controls.holders.value),
            debentureName: self.checkUndefinedValue(self.personaldetailsForm.controls.debentureName.value),
            jointholder: self.checkUndefinedValue(self.personaldetailsForm.controls.jointholder.value),
            address: self.checkUndefinedValue(self.personaldetailsForm.controls.address.value),
            panNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.panNumber.value),
            identificationNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.identificationNumber.value),
            nationality: self.checkUndefinedValue(self.personaldetailsForm.controls.nationality.value),
            emailid: self.checkUndefinedValue(self.personaldetailsForm.controls.emailid.value),
            fatherName: self.checkUndefinedValue(self.personaldetailsForm.controls.fatherName.value),
            motherName: self.checkUndefinedValue(self.personaldetailsForm.controls.motherName.value),
            nameOfJointHolder: self.checkUndefinedValue(self.personaldetailsForm.controls.nameOfJointHolder.value),
            jointholderpanNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.jointholderpanNumber.value),
            isMinor: self.checkUndefinedValue(self.personaldetailsForm.controls.isMinor.value),
            passportNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.passportNumber.value),
            adharNumber: self.checkUndefinedValue(self.personaldetailsForm.controls.adharNumber.value),
            voterId: self.checkUndefinedValue(self.personaldetailsForm.controls.voterId.value),
            drivingLicense: self.checkUndefinedValue(self.personaldetailsForm.controls.drivingLicense.value),
            others: self.checkUndefinedValue(self.personaldetailsForm.controls.others.value),
            dateOfBirth: self.setDate(self.personaldetailsForm.controls.dateOfBirth.value),
            guardian: self.checkUndefinedValue(self.personaldetailsForm.controls.guardian.value),
            spouseName: self.checkUndefinedValue(self.personaldetailsForm.controls.spouseName.value),
            maritialstatus: self.checkUndefinedValue(self.personaldetailsForm.controls.maritialstatus.value),
            occupation: self.checkUndefinedValue(self.personaldetailsForm.controls.occupation.value),
            debentureNameBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.debentureNameBodyCorporate.value),
            registeredAddressBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.registeredAddressBodyCorporate.value),
            panNumberBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.panNumberBodyCorporate.value),
            registrationNumberBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.registrationNumberBodyCorporate.value),
            emailIdBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.emailIdBodyCorporate.value),
            authorisedSignatoryBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.authorisedSignatoryBodyCorporate.value),
            designationBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.designationBodyCorporate.value),
            dateOfBoardBodyCorporate: self.setDate(self.personaldetailsForm.controls.dateOfBoardBodyCorporate.value),
            uploadBodyCorporate: self.checkUndefinedValue(self.personaldetailsForm.controls.uploadBodyCorporate.value),
            debentureNameOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.debentureNameOthers.value),
            jointHolderOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.jointHolderOthers.value),
            addressOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.addressOthers.value),
            panNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.panNumberOthers.value),
            identificationNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.identificationNumberOthers.value),
            passportNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.passportNumberOthers.value),
            adharNumberOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.adharNumberOthers.value),
            voterIdOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.voterIdOthers.value),
            drivingLicenseOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.drivingLicenseOthers.value),
            othersOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.othersOthers.value),
            nationalityOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.nationalityOthers.value),
            emailOthers: self.checkUndefinedValue(self.personaldetailsForm.controls.emailOthers.value),
            FileOrignalName: self.checkUndefinedValue(self.resolutionFileName),
            DocumentManagementID: self.checkUndefinedValue(self.documentManagementID),
            UploadDate: new Date(),
          }
          // console.log('personal : '+JSON.stringify(personal));
          self.Mgt2Service.samplemgt2personalRecord(personal).subscribe(response => {
            self.disabledOnClick = false;
            // console.log("response", JSON.stringify(response));
            if (response.status == 0) {
              self.alert.success(response.message);
              self.addPersonalBtn = false;
            } else {
              if(response.err_fields){
                self.alert.error(response.err_fields + ' fields are required or invalid.');
              }else{
                self.alert.error(response.message);
              }
            }
          })
      }  
  }

  saveholdingdata(){
    this.disabledOnClick = true;
    // console.log('editParticularId : ' + this.editParticularId);
    var holding = {
      particularId:this.editParticularId,
      typesOfHolders: this.holdingForm.controls.typesOfHolders.value,
      dateOfDebenture: this.setDate(this.holdingForm.controls.dateOfDebenture.value),
      dateOfreceipt: this.setDate(this.holdingForm.controls.dateOfreceipt.value),
      nomineeName: this.holdingForm.controls.nomineeName.value,
      nomineeAddress: this.holdingForm.controls.nomineeAddress.value,
      noOfDebenture: this.holdingForm.controls.noOfDebenture.value,
      record: this.holdingForm.controls.record.value,
      dateOfCessation: this.setDate(this.holdingForm.controls.dateOfCessation.value),
      isRepayment: this.holdingForm.controls.isRepayment.value,
      chargeIdentificationNumber: this.holdingForm.controls.chargeIdentificationNumber.value,
      dateOfRegister: this.setDate(this.holdingForm.controls.dateOfRegister.value),
      breifParticulars: this.holdingForm.controls.breifParticulars.value,
      interestMandates: this.holdingForm.controls.interestMandates.value,
      instruction: this.holdingForm.controls.instruction.value,
      ref1: this.holdingForm.controls.ref1.value,
      dobDebentureHolderOtherSecurityHolder: this.setDate(this.holdingForm.controls.dobDebentureHolderOtherSecurityHolder.value),
      recordLienOnDebenturesSecuritiesIfAny: this.holdingForm.controls.recordLienOnDebenturesSecuritiesIfAny.value,
      doCessationAsDebentureHolderOtherSecurityHolder: this.setDate(this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolder.value),
      whetherRepaymentoftheDebenturesOtherSecuritiesisSecured: this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.value,
      ifSecuredDoRegistrationOfChangeWithTheROC: this.setDate(this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROC.value),
      chargeIdentificationNumberAllocatedForCharge: this.holdingForm.controls.chargeIdentificationNumberAllocatedForCharge.value,
      briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities: this.holdingForm.controls.briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities.value,
      particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny: this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny.value,
      instructionForSendingNoticesEtcIfAny: this.holdingForm.controls.instructionForSendingNoticesEtcIfAny.value,
      refInCHG7: this.holdingForm.controls.refInCHG7.value,
      dobDebentureHolderOtherSecurityHolderOthers: this.setDate(this.holdingForm.controls.dobDebentureHolderOtherSecurityHolderOthers.value),
      doReceiptOfNomination: this.setDate(this.holdingForm.controls.doReceiptOfNomination.value),
      nameOfNominee: this.holdingForm.controls.nameOfNominee.value,
      addressOfNominee: this.holdingForm.controls.addressOfNominee.value,
      noOfDebenturesSecuritiesKeptInAbeyanceIfAny: this.holdingForm.controls.noOfDebenturesSecuritiesKeptInAbeyanceIfAny.value,
      recordOfLienOnDebenturesSecuritiesIfAny: this.holdingForm.controls.recordOfLienOnDebenturesSecuritiesIfAny.value,
      doCessationAsDebentureHolderOtherSecurityHolderOthers: this.setDate(this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolderOthers.value),
      whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers: this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.value,
      ifSecuredDoRegistrationOfChangeWithTheROCOthers: this.setDate(this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROCOthers.value),
      chargeIdentificationNumberAllocatedForChargeOthers: this.holdingForm.controls.chargeIdentificationNumberAllocatedForChargeOthers.value,
      briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities: this.holdingForm.controls.briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities.value,
      particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers: this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers.value,
      instructionForSendingNoticesEtcIfAnyOthers: this.holdingForm.controls.instructionForSendingNoticesEtcIfAnyOthers.value,
      refInCHG7Others: this.holdingForm.controls.refInCHG7Others.value,
    }
    this.Mgt2Service.samplemgt2holdingRecord(holding).subscribe(response => {
      this.disabledOnClick = false;
      // console.log("response", JSON.stringify(response));
      if (response.status == 0) {
        this.alert.success(response.message);
        this.addHoldingBtn=false;
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

// *************** Set Value to MGT-2 Form **********************
  getMgt2ById(particularId) {
    // console.log('getMgt2ById : '+particularId);
    this.Mgt2Service.updatemgt2(particularId).subscribe(response => {
      this.editMgt2Data = response.data[0];
      // console.log('editMgt2Data ++++ : '+JSON.stringify(this.editMgt2Data));
     // this.secForm.controls.classOfDebenture.setValidators([Validators.required,Validators.pattern("^[a-zA-Z /.,-]*$"), Validators.maxLength(50)]);

      this.securityOnChange(this.editMgt2Data.selectTypes);
      
      this.secForm.controls.selectTypes.setValue(this.editMgt2Data.selectTypes);
      this.secForm.controls.nominalValue.setValue(this.editMgt2Data.nominalValue);
      this.secForm.controls.numberOfDebenture.setValue(this.editMgt2Data.numberOfDebenture);
      this.secForm.controls.classOfDebenture.setValue(this.editMgt2Data.classOfDebenture);
      this.secForm.controls.otherSecurities.setValue(this.editMgt2Data.otherSecurities);
      this.secForm.controls.folioNumber.setValue(this.editMgt2Data.folioNumber);
      if (this.editMgt2Data.personal) {


        if (this.editMgt2Data.personal.DocumentManagementID != null) {
          this.fileAvailable = true;
          this.canRevert = false;
          this.resolutionFileName = this.editMgt2Data.personal.FileOrignalName;
          this.documentManagementID = this.editMgt2Data.personal.DocumentManagementID;
        }

        this.editMgt2Data.personal.jointholder=='true'?this.showHolderYesClick():this.hideHolderNoClick();
        this.editMgt2Data.personal.isMinor=='true'?this.showMinorYesClick():this.hideMinorNoClick();
        // if(this.editMgt2Data.personal.maritialstatus=='married' && this.minorNo){

        // }
        if (this.editMgt2Data.personal.maritialstatus=='married' && this.minorNo) {
          this.showTermLoadFields = true;
        }
        // if(this.editMgt2Data.personal.holders=='individual'){ this.onIndividualSelect(); }
        // else if(this.editMgt2Data.personal.holders=='bodyCorporate'){ this.onBodyCorporateSelect(); }
        // else if(this.editMgt2Data.personal.holders=='others'){ this.onOtherSelect(); }

        this.addPersonalBtn = false;
        this.personaldetailsForm.controls.holders.setValue(this.editMgt2Data.personal.holders);
        this.personaldetailsForm.controls.debentureName.setValue(this.editMgt2Data.personal.debentureName);
        this.personaldetailsForm.controls.jointholder.setValue(this.editMgt2Data.personal.jointholder);
        this.personaldetailsForm.controls.address.setValue(this.editMgt2Data.personal.address);
        this.personaldetailsForm.controls.panNumber.setValue(this.editMgt2Data.personal.panNumber);
        this.personaldetailsForm.controls.identificationNumber.setValue(this.editMgt2Data.personal.identificationNumber);
        this.personaldetailsForm.controls.nationality.setValue(this.editMgt2Data.personal.nationality);
        this.personaldetailsForm.controls.emailid.setValue(this.editMgt2Data.personal.emailid);
        this.personaldetailsForm.controls.fatherName.setValue(this.editMgt2Data.personal.fatherName);
        this.personaldetailsForm.controls.motherName.setValue(this.editMgt2Data.personal.motherName);
        this.personaldetailsForm.controls.nameOfJointHolder.setValue(this.editMgt2Data.personal.nameOfJointHolder);
        this.personaldetailsForm.controls.jointholderpanNumber.setValue(this.editMgt2Data.personal.jointholderpanNumber);
        this.personaldetailsForm.controls.isMinor.setValue(this.editMgt2Data.personal.isMinor);
        this.personaldetailsForm.controls.passportNumber.setValue(this.editMgt2Data.personal.passportNumber);
        this.personaldetailsForm.controls.adharNumber.setValue(this.editMgt2Data.personal.adharNumber);
        this.personaldetailsForm.controls.voterId.setValue(this.editMgt2Data.personal.voterId);
        this.personaldetailsForm.controls.drivingLicense.setValue(this.editMgt2Data.personal.drivingLicense);
        this.personaldetailsForm.controls.others.setValue(this.editMgt2Data.personal.others);
        this.personaldetailsForm.controls.dateOfBirth.setValue(this.editMgt2Data.personal.dateOfBirth);
        this.personaldetailsForm.controls.guardian.setValue(this.editMgt2Data.personal.guardian);
        this.personaldetailsForm.controls.spouseName.setValue(this.editMgt2Data.personal.spouseName);
        this.personaldetailsForm.controls.maritialstatus.setValue(this.editMgt2Data.personal.maritialstatus);
        this.personaldetailsForm.controls.occupation.setValue(this.editMgt2Data.personal.occupation);
        this.personaldetailsForm.controls.debentureNameBodyCorporate.setValue(this.editMgt2Data.personal.debentureNameBodyCorporate);
        this.personaldetailsForm.controls.registeredAddressBodyCorporate.setValue(this.editMgt2Data.personal.registeredAddressBodyCorporate);
        this.personaldetailsForm.controls.panNumberBodyCorporate.setValue(this.editMgt2Data.personal.panNumberBodyCorporate);
        this.personaldetailsForm.controls.registrationNumberBodyCorporate.setValue(this.editMgt2Data.personal.registrationNumberBodyCorporate);
        this.personaldetailsForm.controls.emailIdBodyCorporate.setValue(this.editMgt2Data.personal.emailIdBodyCorporate);
        this.personaldetailsForm.controls.authorisedSignatoryBodyCorporate.setValue(this.editMgt2Data.personal.authorisedSignatoryBodyCorporate);
        this.personaldetailsForm.controls.designationBodyCorporate.setValue(this.editMgt2Data.personal.designationBodyCorporate);
        this.personaldetailsForm.controls.dateOfBoardBodyCorporate.setValue(this.editMgt2Data.personal.dateOfBoardBodyCorporate);
        this.personaldetailsForm.controls.uploadBodyCorporate.setValue(this.editMgt2Data.personal.uploadBodyCorporate);
        this.personaldetailsForm.controls.debentureNameOthers.setValue(this.editMgt2Data.personal.debentureNameOthers);
        this.personaldetailsForm.controls.jointHolderOthers.setValue(this.editMgt2Data.personal.jointHolderOthers);
        this.personaldetailsForm.controls.addressOthers.setValue(this.editMgt2Data.personal.addressOthers);
        this.personaldetailsForm.controls.panNumberOthers.setValue(this.editMgt2Data.personal.panNumberOthers);
        this.personaldetailsForm.controls.identificationNumberOthers.setValue(this.editMgt2Data.personal.identificationNumberOthers);
        this.personaldetailsForm.controls.passportNumberOthers.setValue(this.editMgt2Data.personal.passportNumberOthers);
        this.personaldetailsForm.controls.adharNumberOthers.setValue(this.editMgt2Data.personal.adharNumberOthers);
        this.personaldetailsForm.controls.voterIdOthers.setValue(this.editMgt2Data.personal.voterIdOthers);
        this.personaldetailsForm.controls.drivingLicenseOthers.setValue(this.editMgt2Data.personal.drivingLicenseOthers);
        this.personaldetailsForm.controls.othersOthers.setValue(this.editMgt2Data.personal.othersOthers);
        this.personaldetailsForm.controls.nationalityOthers.setValue(this.editMgt2Data.personal.nationalityOthers);
        this.personaldetailsForm.controls.emailOthers.setValue(this.editMgt2Data.personal.emailOthers);
        

        if (this.editMgt2Data.personal.dateOfBirth != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.personal.dateOfBirth));
          this.dateOfBirthModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (this.editMgt2Data.personal.dateOfBoardBodyCorporate != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.personal.dateOfBoardBodyCorporate));
          this.dateOfBoardModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if(this.resolutionFileName == null || this.resolutionFileName == ""){
          this.fileAvailable = false;
        }
      } else {
        this.addPersonalBtn = true;
      }

      if (this.editMgt2Data.holding) {

        this.editMgt2Data.holding.isRepayment=='true'?this.showRepaymentYesClick():this.hideRepaymentNoClick();

        this.addHoldingBtn = false;
        this.holdingForm.controls.typesOfHolders.setValue(this.editMgt2Data.holding.typesOfHolders);
        // this.holdingForm.controls.dateOfDebenture.setValue(this.editMgt2Data.holding.dateOfDebenture);
        // this.holdingForm.controls.dateOfreceipt.setValue(this.editMgt2Data.holding.dateOfreceipt);
        this.holdingForm.controls.nomineeName.setValue(this.editMgt2Data.holding.nomineeName);
        this.holdingForm.controls.nomineeAddress.setValue(this.editMgt2Data.holding.nomineeAddress);
        this.holdingForm.controls.noOfDebenture.setValue(this.editMgt2Data.holding.noOfDebenture);
        this.holdingForm.controls.record.setValue(this.editMgt2Data.holding.record);
        // this.holdingForm.controls.dateOfCessation.setValue(this.editMgt2Data.holding.dateOfCessation);
        this.holdingForm.controls.isRepayment.setValue(this.editMgt2Data.holding.isRepayment);
        this.holdingForm.controls.chargeIdentificationNumber.setValue(this.editMgt2Data.holding.chargeIdentificationNumber);
        // this.holdingForm.controls.dateOfRegister.setValue(this.editMgt2Data.holding.dateOfRegister);
        this.holdingForm.controls.breifParticulars.setValue(this.editMgt2Data.holding.breifParticulars);
        this.holdingForm.controls.interestMandates.setValue(this.editMgt2Data.holding.interestMandates);
        this.holdingForm.controls.instruction.setValue(this.editMgt2Data.holding.instruction);
        this.holdingForm.controls.ref1.setValue(this.editMgt2Data.holding.ref1);
        // this.holdingForm.controls.dobDebentureHolderOtherSecurityHolder.setValue(this.editMgt2Data.holding.dobDebentureHolderOtherSecurityHolder);
        this.holdingForm.controls.recordLienOnDebenturesSecuritiesIfAny.setValue(this.editMgt2Data.holding.recordLienOnDebenturesSecuritiesIfAny);
        // this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolder.setValue(this.editMgt2Data.holding.doCessationAsDebentureHolderOtherSecurityHolder);
        this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured.setValue(this.editMgt2Data.holding.whetherRepaymentoftheDebenturesOtherSecuritiesisSecured);
        // this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROC.setValue(this.editMgt2Data.holding.ifSecuredDoRegistrationOfChangeWithTheROC);
        this.holdingForm.controls.chargeIdentificationNumberAllocatedForCharge.setValue(this.editMgt2Data.holding.chargeIdentificationNumberAllocatedForCharge);
        this.holdingForm.controls.briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities.setValue(this.editMgt2Data.holding.briefParticularsOfAssetsToSecureSuchDebenturesOtherSecurities);
        this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny.setValue(this.editMgt2Data.holding.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAny);
        this.holdingForm.controls.instructionForSendingNoticesEtcIfAny.setValue(this.editMgt2Data.holding.instructionForSendingNoticesEtcIfAny);
        this.holdingForm.controls.refInCHG7.setValue(this.editMgt2Data.holding.refInCHG7);
        // this.holdingForm.controls.dobDebentureHolderOtherSecurityHolderOthers.setValue(this.editMgt2Data.holding.dobDebentureHolderOtherSecurityHolderOthers);
        // this.holdingForm.controls.doReceiptOfNomination.setValue(this.editMgt2Data.holding.doReceiptOfNomination);
        this.holdingForm.controls.nameOfNominee.setValue(this.editMgt2Data.holding.nameOfNominee);
        this.holdingForm.controls.addressOfNominee.setValue(this.editMgt2Data.holding.addressOfNominee);
        this.holdingForm.controls.noOfDebenturesSecuritiesKeptInAbeyanceIfAny.setValue(this.editMgt2Data.holding.noOfDebenturesSecuritiesKeptInAbeyanceIfAny);
        this.holdingForm.controls.recordOfLienOnDebenturesSecuritiesIfAny.setValue(this.editMgt2Data.holding.recordOfLienOnDebenturesSecuritiesIfAny);
        // this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolderOthers.setValue(this.editMgt2Data.holding.doCessationAsDebentureHolderOtherSecurityHolderOthers);
        this.holdingForm.controls.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers.setValue(this.editMgt2Data.holding.whetherRepaymentoftheDebenturesOtherSecuritiesisSecuredOthers);
        //this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROCOthers.setValue(this.editMgt2Data.holding.ifSecuredDoRegistrationOfChangeWithTheROCOthers);
        this.holdingForm.controls.chargeIdentificationNumberAllocatedForChargeOthers.setValue(this.editMgt2Data.holding.chargeIdentificationNumberAllocatedForChargeOthers);
        this.holdingForm.controls.briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities.setValue(this.editMgt2Data.holding.briefParticularsOfTheAssetsToSecureSuchDebenturesOtherSecurities);
        this.holdingForm.controls.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers.setValue(this.editMgt2Data.holding.particularsOfInterestMandatesPowerOfAttorneyAndOtherInstructionsIfAnyOthers);
        this.holdingForm.controls.instructionForSendingNoticesEtcIfAnyOthers.setValue(this.editMgt2Data.holding.instructionForSendingNoticesEtcIfAnyOthers);
        this.holdingForm.controls.refInCHG7Others.setValue(this.editMgt2Data.holding.refInCHG7Others);
        


        if (this.editMgt2Data.holding.dateOfDebenture != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.dateOfDebenture));
          this.DateOfDebentureModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.dateOfDebenture.setValue(null);
        }

        if (this.editMgt2Data.holding.dateOfreceipt != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.dateOfreceipt));
          this.DateOfreceiptModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.dateOfreceipt.setValue(null);
        }

        if (this.editMgt2Data.holding.dateOfCessation != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.dateOfCessation));
          this.dateOfCessationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.dateOfCessation.setValue(null);
        }

        if (this.editMgt2Data.holding.dateOfRegister != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.dateOfRegister));
          this.dateOfRegisterModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.dateOfRegister.setValue(null);
        }
        
        if (this.editMgt2Data.holding.dobDebentureHolderOtherSecurityHolder != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.dobDebentureHolderOtherSecurityHolder));
          this.dateOfDebentureHolderModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.dobDebentureHolderOtherSecurityHolder.setValue(null);
        }

        if (this.editMgt2Data.holding.ifSecuredDoRegistrationOfChangeWithTheROC != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.ifSecuredDoRegistrationOfChangeWithTheROC));
          this.dateOfRegistrationModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROC.setValue(null);
        }

        if (this.editMgt2Data.holding.doCessationAsDebentureHolderOtherSecurityHolder != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.doCessationAsDebentureHolderOtherSecurityHolder));
          this.dateOfCessationDebentureHolderModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolder.setValue(null);
        }

        if (this.editMgt2Data.holding.doReceiptOfNomination != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.doReceiptOfNomination));
          this.dateOfReceiptModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.doReceiptOfNomination.setValue(null);
        }

        
        if (this.editMgt2Data.holding.dobDebentureHolderOtherSecurityHolderOthers != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.dobDebentureHolderOtherSecurityHolderOthers));
          this.dateOfCessationDebentureHolderModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.dobDebentureHolderOtherSecurityHolderOthers.setValue(null);
        }

        if (this.editMgt2Data.holding.doCessationAsDebentureHolderOtherSecurityHolderOthers != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.doCessationAsDebentureHolderOtherSecurityHolderOthers));
          this.dateOfCessationDebentureHolderOtherModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.doCessationAsDebentureHolderOtherSecurityHolderOthers.setValue(null);
        }

        if (this.editMgt2Data.holding.ifSecuredDoRegistrationOfChangeWithTheROCOthers != null) {
          let dt = new Date(this.setFormatDate(this.editMgt2Data.holding.ifSecuredDoRegistrationOfChangeWithTheROCOthers));
          this.dateOfRegistrationROCOthersModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }else{
          this.holdingForm.controls.ifSecuredDoRegistrationOfChangeWithTheROCOthers.setValue(null);
        }

      } else {
        this.addHoldingBtn = true;
      }
    })
  }

// ******************* Personal Details Upload Document Functionality ********************
  fileChangeEvent(fileInput: any) {
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
     if(checkfile){
      this.filesToUpload = <Array<File>>fileInput.target.files;
      this.fileExtension = true;
     }else{
      this.fileExtension = false;
     }
    
    this.canRevert = false;
    setTimeout(() => {
      if (fileInput.target.files[0] == undefined) {
        this.resolutionFileName = "";
        this.documentManagementID = null;
      }
      fileInput = null;
    }, 1000);
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = name;
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  upload() {
    var file = this.filesToUpload;
    return this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      if (result) {
        var document = {
          "DocumentManagement": {
            "DocumentName": Date.now() + " - Document (MGT-2)",
            "DateOfDocument": new Date(),
            "CompletedDate": null,
            "MeetingTypeID": null,
            "ParentDocumentTypeID": null,
            "ParentSubDocumentTypeID": null,
            "DirectorKmp": "None",
            "DirectorID": null,
            "KMPID": null,
            "Remarks": "",
            "Overwrite": false,
            "Upload": this.changedName,
            "OriginalFileName": this.FileOrignalName,
            "FilePath": "",
            "CreatedBy": null,
            "CreatedDate": new Date(),
            "LastUpdateFiles": new Date(),
            "ModifiedBy": null,
            "ModifiedDate": null,
          }
        }
        return this.documentManagementMasterService.addDocumentManagement(document)
          .toPromise().then(res => { return Promise.resolve(res); })

      }
    });
  }
  addFilesOnUpdate() {
    this.fileAvailable = false;
    this.canRevert = true;
  }

  downloadCtcDoc(id) {
    window.location.href = environment.pssServerUrl + this.downloadAllLink + id + '/' + this.token;
    
  }
  revert() {
    this.canRevert = false;
    this.fileAvailable = true;
  }
  removeFile() {
    this.fileAvailable = false;
    this.filesToUpload = [];
    this.resolutionFileName = "";
    this.documentManagementID = null;
  }


// ******************* Details Of Security Functionality ********************
  addNewFieldsModal() {
  
    this.addButton=true;
   // this.deleteButton=true;
   // this.securityUpdate=true;
    $("#addNewForm").modal('toggle');
    this.addNewFields();
  }

  addNewFields() {
    var formArray: FormArray = <FormArray>this.addSecurityForm.controls.newField;
     var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);
  }

  resetFields(){
    var formArray: FormArray = <FormArray>this.addSecurityForm.controls.newField;
    const index = _.size(formArray.controls);
    for(let i = index-1; i >= 0; i--) {
      this.newFieldArray.splice(i, 1);
      formArray = <FormArray>this.addSecurityForm.controls.newField;
      formArray.removeAt(i)
      }
  }

  removeField(index) {
    var newFieldData = this.addSecurityForm.controls.newField.value;
    this.newFieldArray.splice(index, 1);
    var formArray = <FormArray>this.addSecurityForm.controls.newField;
    formArray.removeAt(index)
  }

  initialiseNewFieldArray(): FormGroup {
    return this.fb.group({
      typeOfHolding: new FormControl('',[Validators.required]),
      allotmentNumber: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /,.-]*$"), Validators.maxLength(20)]),
      datebuyback: new FormControl(null,[]),
      numberOfDebentures: new FormControl('',[Validators.pattern("^[0-9 /.-]*$"), Validators.maxLength(20)]),
      distinctiveNumberFrom: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(20)]),
      distinctiveNumberTo: new FormControl('',[Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(20)]),
      folioTransferor: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      nameOfTransferor: new FormControl('',[Validators.pattern("^[a-zA-Z0-9 &,.-]*$"), Validators.maxLength(100)]),
      dateOfIssue:new FormControl(null,[]),
      certificateNo: new FormControl('',[Validators.required,Validators.pattern("^[a-zA-Z0-9 /.]*$"), Validators.maxLength(20)]),
      amountPayable: new FormControl('',[Validators.pattern("^[0-9 /.]*$"), Validators.maxLength(20)]),
      amountPaid: new FormControl('',[Validators.pattern("^[0-9 /.]*$"), Validators.maxLength(20)]),
      amountDue: new FormControl('',[Validators.pattern("^[0-9 /.]*$"), Validators.maxLength(20)]),
      debenturesOtherSecurities:new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /&,.-]*$"), Validators.maxLength(1000)]),
      dateOfTransfer:new FormControl(null,[]),
      noOfUnitsTransferred:new FormControl('',[Validators.pattern("^[0-9 /,.-]*$"), Validators.maxLength(20)]),
      distinctiveNumbersFrom:new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      distinctiveNumbersTo:new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /]*$"), Validators.maxLength(20)]),
      folioOfTransferee:new FormControl('',[Validators.pattern("^[a-zA-Z0-9 /,.-]*$"), Validators.maxLength(20)]),
      nameOfTransferee:new FormControl('',[Validators.pattern("^[a-zA-Z0-9 &/,.-]*$"), Validators.maxLength(100)]),
      balanceUnitsLeft:new FormControl('',[Validators.pattern("^[0-9]*$"), Validators.maxLength(20)]),
      otherRemarks:new FormControl('',[Validators.pattern("^[a-zA-Z0-9 &/,.-]*$"), Validators.maxLength(1000)])
    })
  }

  saveSecurityDetails()
  {
    this.disabledOnClick = true;
    // if(this.addSecurityForm.valid){
      // var object = {
      //   particularId: this.editParticularId,
      //   data:this.addSecurityForm.controls.newField.value
      // };
      this.holdersdata = [];
      // var addSecurityFormData=[];
      // for (var i = 0; i < this.addSecurityForm.controls.newField.value.length; i++) { 
      //   addSecurityFormData.push({
        this.addSecurityForm.controls.newField.value.forEach((item, i)=>{
          let updatedObject ={
          typeOfHolding: this.addSecurityForm.controls.newField.value[i].typeOfHolding,
          allotmentNumber: this.addSecurityForm.controls.newField.value[i].allotmentNumber,
          datebuyback: this.setDate(this.addSecurityForm.controls.newField.value[i].datebuyback),
          numberOfDebentures: this.addSecurityForm.controls.newField.value[i].numberOfDebentures,
          distinctiveNumberFrom: this.addSecurityForm.controls.newField.value[i].distinctiveNumberFrom,
          distinctiveNumberTo: this.addSecurityForm.controls.newField.value[i].distinctiveNumberTo,
          folioTransferor: this.addSecurityForm.controls.newField.value[i].folioTransferor,
          nameOfTransferor: this.addSecurityForm.controls.newField.value[i].nameOfTransferor,
          dateOfIssue: this.setDate(this.addSecurityForm.controls.newField.value[i].dateOfIssue),
          certificateNo: this.addSecurityForm.controls.newField.value[i].certificateNo,
          amountPayable: this.addSecurityForm.controls.newField.value[i].amountPayable,
          amountPaid: this.addSecurityForm.controls.newField.value[i].amountPaid,
          amountDue: this.addSecurityForm.controls.newField.value[i].amountDue,
          debenturesOtherSecurities: this.addSecurityForm.controls.newField.value[i].debenturesOtherSecurities,
          dateOfTransfer: this.setDate(this.addSecurityForm.controls.newField.value[i].dateOfTransfer),
          noOfUnitsTransferred: this.addSecurityForm.controls.newField.value[i].noOfUnitsTransferred,
          distinctiveNumbersFrom: this.addSecurityForm.controls.newField.value[i].distinctiveNumbersFrom,
          distinctiveNumbersTo: this.addSecurityForm.controls.newField.value[i].distinctiveNumbersTo,
          folioOfTransferee: this.addSecurityForm.controls.newField.value[i].folioOfTransferee,
          nameOfTransferee: this.addSecurityForm.controls.newField.value[i].nameOfTransferee,
          balanceUnitsLeft: this.addSecurityForm.controls.newField.value[i].balanceUnitsLeft,
          otherRemarks: this.addSecurityForm.controls.newField.value[i].otherRemarks
      //   });
       }
       console.log("updatedObject ",updatedObject);

      this.holdersdata.push(updatedObject);
    });

      var object = {
        particularId: this.editParticularId,
        data: this.holdersdata
      };

      // console.log("newField", JSON.stringify(object));
      
      this.Mgt2Service.addDetailsOfSecurity(object).subscribe(response => {
        this.disabledOnClick = false;
          console.log("saveresponse :", response);
          if (response.status == 0) {
            this.alert.success(response.message);
            this.getHoldingList();
            $("#detailsOfHoldinglistTable").DataTable().destroy();
         
          } else {
            $("#detailsOfHoldinglistTable").DataTable().destroy();
            if(response.err_fields){
              this.alert.error(response.err_fields + ' fields are required or invalid.');
            }else{
              this.alert.error(response.message);
            }
            $("#addNewForm .close").click()
          }
         //this.getHoldingList();
          $("#addNewForm .close").click()
          this.resetFields();
      })
    // }else{
    //   $("#detailsOfHoldinglistTable").DataTable().destroy();
    //   this.alert.error('Details of security is not valid');
    //   $("#addNewForm .close").click()
    // }
  }

  getHoldingList() {
    this.holdingList = [];
    var Id = this.editParticularId;
    console.log(Id)
    var searchParam =
    {
      "dateFrom": null,
      "dateTo": null,
      'isSearch': false,
    };
    this.Mgt2Service.getSecurityDetailsList(Id, searchParam).subscribe(holdingList => {
        // var list = holdingList.data;
        this.holdingList = holdingList.data;
        console.log("holdingList*****getttt****", this.holdingList);
        this.dtTriggerHolding.next();
    });
  }
  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "dateFrom":this.setDate(this.dateFrom),
      "dateTo":this.setDate(this.dateTo),
      'isSearch': true,
    };
    this.holdingList = [];
     $("#detailsOfHoldinglistTable").DataTable().destroy();
    var Id = this.editParticularId;
    this.Mgt2Service.getSecurityDetailsList(Id ,searchParam).subscribe(holdingList => {
      console.log("holdingList*********", holdingList);
      this.response = false;
      var list = holdingList.data;
      this.holdingList = holdingList.data;
      console.log("holdingList*********", this.holdingList);
      this.dtTriggerHolding.next();
    });
  }

  clearAdvSearch() {
  
    this.dateFrom  = undefined;
    this.dateTo  = undefined;
     $("#detailsOfHoldinglistTable").DataTable().destroy();
    this.getHoldingList();
  }

  // editSecurityDetails(recordId)
  // {
  
  //   var Id = this.editParticularId;
  //   var searchParam =
  //   {
  //     "dateFrom": null,
  //     "dateTo": null,
  //     'isSearch': false,
  //   };
  //   this.Mgt2Service.getSecurityDetailsList(Id, searchParam).subscribe(response => {
          
  //         var responseList = response.data.securitiesDetails;
  //         console.log("*****responseList*********",responseList)
  //         responseList.securitiesDetails.forEach(data => { 
  //           if(data._id==recordId)
  //           {
  //             $("#addNewForm").modal('toggle');
 
  //           // this.addNewFields();

  //             this.deleteButton=false;
   
  //             var formArray: FormArray = <FormArray>this.addSecurityForm.controls.newField;
  //             var formGroup: FormGroup = <FormGroup>formArray.controls[0];
              

  //             formGroup.get('typeOfHolding').setValue(data.typeOfHolding);
  //             formGroup.get('allotmentNumber').setValue(data.allotmentNumber);

  //             if (data.datebuyback != null) {
  //               let dt = new Date(data.datebuyback);
  //               var datebuybackNew = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
  //               formGroup.get('datebuyback').setValue(datebuybackNew);
  //             }else{
  //                 formGroup.get('datebuyback').setValue(null);
  //             }

  //             formGroup.get('numberOfDebentures').setValue(data.numberOfDebentures);
  //             formGroup.get('distinctiveNumberFrom').setValue(data.distinctiveNumberFrom);
  //             formGroup.get('distinctiveNumberTo').setValue(data.distinctiveNumberTo);
  //             formGroup.get('folioTransferor').setValue(data.folioTransferor);
  //             formGroup.get('nameOfTransferor').setValue(data.nameOfTransferor);

  //             if (data.dateOfIssue != null) {
  //               let dt = new Date(data.dateOfIssue);
  //               var dateOfIssueNew = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
  //               formGroup.get('dateOfIssue').setValue(dateOfIssueNew);
  //             }else{
  //                 formGroup.get('dateOfIssue').setValue(null);
  //             }

  //             formGroup.get('certificateNo').setValue(data.certificateNo);
  //             formGroup.get('amountPayable').setValue(data.amountPayable);
  //             formGroup.get('amountPaid').setValue(data.amountPaid);
  //             formGroup.get('amountDue').setValue(data.amountDue);
  //             formGroup.get('debenturesOtherSecurities').setValue(data.debenturesOtherSecurities);
            

  //             if (data.dateOfTransfer != null) {
  //               let dt = new Date(data.dateOfTransfer);
  //               var dateOfTransferNew = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
  //               formGroup.get('dateOfTransfer').setValue(dateOfTransferNew);
  //             }else{
  //                 formGroup.get('dateOfTransfer').setValue(null);
  //             }

  //             formGroup.get('noOfUnitsTransferred').setValue(data.noOfUnitsTransferred);
  //             formGroup.get('distinctiveNumbersFrom').setValue(data.distinctiveNumbersFrom);
  //             formGroup.get('distinctiveNumbersTo').setValue(data.distinctiveNumbersTo);
  //             formGroup.get('folioOfTransferee').setValue(data.folioOfTransferee);
  //             formGroup.get('nameOfTransferee').setValue(data.nameOfTransferee);
  //             formGroup.get('balanceUnitsLeft').setValue(data.balanceUnitsLeft);
  //             formGroup.get('otherRemarks').setValue(data.otherRemarks);
  //             this.updateRecordId=recordId;
  //           }
  //         });  
  //   });
  // }

  editSecurityDetails(id)
  {
    
    // this.securityUpdate=false;
   
     this.addButton=false;
    // this.deleteButton=false;
    var data =  this.holdingList.filter(function(item) {
      return item.securitiesDetails._id == id;
    });
    this.holdingdata = data[0].securitiesDetails;
    console.log("************editthis.holdingdata",this.holdingdata);
    $("#addNewForm").modal('toggle');

    var formArray: FormArray = <FormArray>this.addSecurityForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];
    
    console.log("addSecurityForm", this.addSecurityForm);
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);

    formGroup.controls.typeOfHolding.setValue(this.holdingdata.typeOfHolding);
    formGroup.controls.allotmentNumber.setValue(this.holdingdata.allotmentNumber);
    formGroup.controls.numberOfDebentures.setValue(this.holdingdata.numberOfDebentures);
    formGroup.controls.distinctiveNumberFrom.setValue(this.holdingdata.distinctiveNumberFrom);
    formGroup.controls.distinctiveNumberTo.setValue(this.holdingdata.distinctiveNumberTo);
    formGroup.controls.folioTransferor.setValue(this.holdingdata.folioTransferor);
    formGroup.controls.nameOfTransferor.setValue(this.holdingdata.nameOfTransferor);
    formGroup.controls.certificateNo.setValue(this.holdingdata.certificateNo);
    formGroup.controls.amountPayable.setValue(this.holdingdata.amountPayable);
    formGroup.controls.amountPaid.setValue(this.holdingdata.amountPaid);
    formGroup.controls.amountDue.setValue(this.holdingdata.amountDue);
    formGroup.controls.debenturesOtherSecurities.setValue(this.holdingdata.debenturesOtherSecurities);
    formGroup.controls.noOfUnitsTransferred.setValue(this.holdingdata.noOfUnitsTransferred);
    formGroup.controls.distinctiveNumbersFrom.setValue(this.holdingdata.distinctiveNumbersFrom);
    formGroup.controls.distinctiveNumbersTo.setValue(this.holdingdata.distinctiveNumbersTo);
    formGroup.controls.folioOfTransferee.setValue(this.holdingdata.folioOfTransferee);
    formGroup.controls.nameOfTransferee.setValue(this.holdingdata.nameOfTransferee);
    formGroup.controls.balanceUnitsLeft.setValue(this.holdingdata.balanceUnitsLeft);
    formGroup.controls.otherRemarks.setValue(this.holdingdata.otherRemarks);
   
   // this.pipe = new DatePipe('en-US');

   

    if (this.holdingdata.datebuyback != null) {
      let dt = new Date(this.setFormatDate(this.holdingdata.datebuyback));
      formGroup.controls.datebuyback.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }

    if (this.holdingdata.dateOfIssue != null) {
      let dt = new Date(this.setFormatDate(this.holdingdata.dateOfIssue));
      formGroup.controls.dateOfIssue.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }

    if (this.holdingdata.dateOfTransfer != null) {
      let dt = new Date(this.setFormatDate(this.holdingdata.dateOfTransfer));
      formGroup.controls.dateOfTransfer.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }

  }

  dateSet(date) {

    if (date != "" && date != null) {
      if(date.month != undefined && date.day != undefined && date.year != undefined){
        return date.month + "-" + date.day + "-" + date.year;
      }
      else return date;
    }
    return null;
  }



  updateSecurityDetails()
  {
    this.disabledOnClick = true;
   
    this.array = this.addSecurityForm.controls.newField;
    var item = this.array.controls[0];
    
        var holddata = {
          _id: this.holdingdata._id,
          typeOfHolding: item.controls.typeOfHolding.value,
          allotmentNumber: item.controls.allotmentNumber.value,
          datebuyback:  this.dateSet(item.controls.datebuyback.value),
          numberOfDebentures: item.controls.numberOfDebentures.value,
          distinctiveNumberFrom: item.controls.distinctiveNumberFrom.value,
          distinctiveNumberTo: item.controls.distinctiveNumberTo.value,
          folioTransferor: item.controls.folioTransferor.value,
          nameOfTransferor: item.controls.nameOfTransferor.value,
          dateOfIssue:  this.dateSet(item.controls.dateOfIssue.value),
          certificateNo: item.controls.certificateNo.value,
          amountPayable: item.controls.amountPayable.value,
          amountPaid: item.controls.amountPaid.value,
          amountDue: item.controls.amountDue.value,
          debenturesOtherSecurities: item.controls.debenturesOtherSecurities.value,
          dateOfTransfer:  this.dateSet(item.controls.dateOfTransfer.value),
          noOfUnitsTransferred: item.controls.noOfUnitsTransferred.value,
          distinctiveNumbersFrom: item.controls.distinctiveNumbersFrom.value,
          distinctiveNumbersTo: item.controls.distinctiveNumbersTo.value,
          folioOfTransferee: item.controls.folioOfTransferee.value,
          nameOfTransferee: item.controls.nameOfTransferee.value,
          balanceUnitsLeft: item.controls.balanceUnitsLeft.value,
          otherRemarks: item.controls.otherRemarks.value
     
        }
   
        var object = {
          particularId: this.editParticularId,
          id: this.holdingdata._id,
          data:holddata
        };
        
        this.Mgt2Service.updateSecurityDetailsData(object).subscribe(response => {
          this.disabledOnClick = false;
          console.log("updatedddddddddresponse :", response);
          if (response.status == 0) {
        
            this.alert.success(response.message);
             this.getHoldingList();
          } else {
           
            if(response.err_fields){
              this.alert.error(response.err_fields + ' fields are required or invalid.');
            }else{
              this.alert.error(response.message);
            }
             this.resetFields();
            $("#detailsOfHoldinglistTable").DataTable().destroy();
          }
         
         this.resetFields();
      })
 
    this.addButton = true;
    $("#detailsOfHoldinglistTable").DataTable().destroy();
    $("#addNewForm .close").click()
  }

  setDateFormat(dateValue)
  {
    // mm/dd/yyyy
    if(dateValue == null)
    { return ""; }
    const currentDate = new Date(dateValue);
    return currentDate.toISOString().substring(0,10);
  }

  confirmDelete(_id) {
    this.deleteholdingId = _id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteholdingdetail() {
    var Id = this.editParticularId;
     this.Mgt2Service.deleteSecurityDetails(this.deleteholdingId, Id).subscribe(response => {
       if (response.status == 0) {
        $("#detailsOfHoldinglistTable").DataTable().destroy();
        $("#deleteConfirm").modal('toggle');
        this.alert.success(response.message);         
       } else {
         this.alert.error(response.message);
       }
       this.getHoldingList();
     });
   }



}
